import React from 'react';

export default function ServicesHeader() {
  return (
    <section>
      <h1 className="mb-3">Additional Services</h1>

      <p>Please choose additional services that you’d like to add to your policy.</p>
    </section>
  );
}
